import { createSelector } from "@reduxjs/toolkit";

import type { RootState } from "types";

export const getBriefings = createSelector(
  (state: RootState) => state.briefingGeneration.briefings.byId,
  (briefingsById) => Object.values(briefingsById),
);
